<template>
  <main-layout>
    <iframe
      sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
      allowfullscreen="true"
      :src="src"
      :style="{
        display: 'block',
        border: 'none',
        position: 'absolute',
        width: '100%',
        height: 'calc(100dvh - var(--nav-height))'
      }"
    />
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['currentLang']),
    src() {
      if (!this.currentLang) return ''
      return `https://cms.vibe-vote.zwiz.app/${this.currentLang}/report/result`
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      if (event.data.event_id === 'open_external_link') {
        if (window.innerWidth < 960) {
          window.open(event.data.url, '_blank')
        } else {
          this.downloadFile(event.data.url, `file_${Date.now()}`)
        }
      } else if (event.data.event_id === 'copy_to_clipboard') {
        if (event.data.value) navigator.clipboard.writeText(event.data.value)
      } else if (event.data.event_id === 'open_link') {
        window.open(event.data.url, '_self')
      }
    },
    downloadFile(url, filename) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = blobUrl
          a.download = filename
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          URL.revokeObjectURL(blobUrl)
        })
        .catch((error) => console.error('Download failed:', error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/vibe-vote/ReportIframe.vue